var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useMemo, useState } from "react";
import { VirtusPasswordValidator, virtusPasswordValidatorDefaultRules, } from "../utils/VirtusPasswordValidator";
export function useVirtusPasswordValidator(password) {
    var _a = __read(useState({}), 2), passwordRulesPassedObj = _a[0], setPasswordRulesPassedObj = _a[1];
    // don't re-instantiate a new VirtusPasswordValidator object on every re-render
    var virtusPasswordValidator = useMemo(function () { return new VirtusPasswordValidator(virtusPasswordValidatorDefaultRules); }, []);
    useEffect(function () {
        setPasswordRulesPassedObj(virtusPasswordValidator.check(password));
    }, [password]);
    var addRule = function (passwordRule) {
        return virtusPasswordValidator.addRule(passwordRule);
    };
    var removeRule = function (passwordRuleNameKey) {
        return virtusPasswordValidator.removeRule(passwordRuleNameKey);
    };
    var doAllRulesPass = function (password) {
        return virtusPasswordValidator.doAllRulesPass(password);
    };
    return [passwordRulesPassedObj, addRule, removeRule, doAllRulesPass];
}
